import * as z from 'zod';

export type LoginFormValues = z.infer<typeof loginFormSchema>;

export const loginFormSchema = z.object({
  email: z.coerce.string().email({
    message: 'Please enter a valid email address',
  }),
  password: z.string().nonempty({
    message: 'This field is required',
  }),
});

export const DEFAULT_FORM_VALUES: LoginFormValues = {
  email: '',
  password: '',
};
